import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { GiveAccessController } from 'fragments/passcodes/fragments/give-access/interfaces';
import { useAPIAnnouncements } from 'services/announcements/api-announcements.service';
import { AdminSite } from 'services/announcements/announcements.service';

export const useGiveAccessController = (): GiveAccessController => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { getAdminSites } = useAPIAnnouncements();

    const accessToken = searchParams.get('access_token') || '';
    const qs = `access_token=${accessToken}`;

    const [adminSites, setAdminSites] = useState<AdminSite[]>([]);

    useEffect(() => {
        if (!accessToken) {
            return;
        }
        getAdminSites(accessToken)
            .then(setAdminSites)
            .catch(() => {
                // best-effort: si falla, el chooser sigue mostrando sus 2 opciones originales
            });
    }, [accessToken]);

    const onSelectApp = () => navigate(`/mobile/give-access/key?${qs}`);
    const onSelectVisit = () => navigate(`/mobile/give-access/visit?${qs}`);
    const onSelectAnnouncement = () => {
        if (adminSites.length === 1) {
            navigate(`/mobile/announcements/compose?${qs}&site_id=${adminSites[0].siteId}&is_admin=true`);
            return;
        }
        navigate(`/mobile/announcements/select-site?${qs}`);
    };

    return {
        state: { adminSites: adminSites.map((s) => ({ siteId: s.siteId, siteName: s.siteName })) },
        events: { onSelectApp, onSelectVisit, onSelectAnnouncement },
    };
};
